import "../index.css";
import { useState } from "react";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";
import axios from "axios";
import { baseURL } from "../baseURL";

const PopUpFormSponsor = ({ onClose, onSuccess, onError }) => {
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmitSponsorForm = async (e) => {
    e.preventDefault(); // Prevent page reload
    try {
      const response = await axios.post(
        `${baseURL}/api/submit-sponsor-form`,
        formData,
        {
          withCredentials: "true", // This matches the backend CORS policy
          headers: { "Content-Type": "application/json" },
        }
      );
      if (response.status === 200) {
        onSuccess("sponsor");
        onClose();
      }
    } catch (error) {
      console.error("Error submitting form:", error.response || error.message);
      onError(error);
    }
  };

  return (
    <>
      <div className="pop-up-form">
        <div className="form-header">
          <h4>Sponsor Program</h4>
          <div className="close-btn-x" onClick={onClose}>
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <form id="becomesponsorForm" onSubmit={handleSubmitSponsorForm}>
          <p>
            Providing your contact information enables us to share best
            practices, communicate updates, and network with our global wildfire
            prevention community.
          </p>

          <div className="form-group">
            <label htmlFor="firstName">*First Name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">*Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">*Email</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="organization">Organization</label>
            <input
              type="text"
              id="organization"
              name="organization"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="role">Role</label>
            <input type="text" id="role" name="role" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label htmlFor="zipCode">*Zip/Postal Code</label>
            <input
              type="text"
              id="zipCode"
              name="zipCode"
              required
              onChange={handleChange}
              minLength={4}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              onChange={handleChange}
            ></textarea>
          </div>

          <legend>Sponsor</legend>

          <div className="form-check">
            <input type="checkbox" name="meeting" onChange={handleChange} />
            <label>
              Set up a meeting to learn more about CWPC's Sponsor Program
            </label>
          </div>

          <div className="form-check">
            <input type="checkbox" name="information" onChange={handleChange} />
            <label>
              Send me information about CWPC's Sponsor Program Benefits
            </label>
          </div>

          <div className="form-check">
            <input
              type="checkbox"
              name="customSponsor"
              onChange={handleChange}
            />
            <label>Interested in tailoring a custom sponsor program</label>
          </div>

          <legend>Subscribe</legend>

          <div className="form-check">
            <input
              type="checkbox"
              name="receiveUpdate"
              onChange={handleChange}
            />
            <label>
              Receive exclusive updates on events, news, and access to weekly
              Consortium meetings
            </label>
          </div>

          <legend>Sign up</legend>

          <div className="form-check">
            <input
              type="checkbox"
              name="attendMeetings"
              onChange={handleChange}
            />
            <label>Attend weekly Consortium meetings</label>
          </div>
          <Button text="Submit" color="var(--green)" className="pop-up-btn" />
        </form>
        <div className="policy">
          <PolicyContainer text="Submit" />
        </div>
        <div className="form-footer">
          <div className="form-close-btn" onClick={onClose}>
            Close
          </div>
        </div>
      </div>
    </>
  );
};

export default PopUpFormSponsor;
